module.exports = __webpack_public_path__ + "0c7eb497dd49ab4e4e3781d1e0aafe08.png";